import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import styles from './VPFBadge.module.scss'

export default function VPFModal({ show, onHide }) {
  const { t } = useTranslation()

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      fullscreen="md-down"
      scrollable
      enforceFocus={false}
      restoreFocus={false}
      dialogClassName={styles.modalDialog}
    >
      <Modal.Header closeButton>
        <Modal.Title>{t('event.vpf.modal.title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles.modalBody}>
        <h6 className="fw-semibold mb-2">{t('event.vpf.modal.heading')}</h6>
        <p>{t('event.vpf.modal.text1')}</p>
        <p>{t('event.vpf.modal.text2')}</p>
        <p>{t('event.vpf.modal.text3')}</p>
        <p className="mb-0">{t('event.vpf.modal.text4')}</p>
      </Modal.Body>
    </Modal>
  )
}
